import React from "react";
import { Play, Apple } from "lucide-react";
import appMockup from "../assets/billing.jpeg";

const Hero = () => {
  return (
    <section className="relative bg-white pt-20 pb-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          
          {/* Left Content */}
          <div className="text-center lg:text-left z-10">
            <div className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-700 px-4 py-2 rounded-full text-sm font-bold mb-6">
              <span className="flex h-2 w-2 rounded-full bg-emerald-500 animate-ping"></span>
              Trusted by 1000+ Shop Owners
            </div>

            <h1 className="text-5xl lg:text-7xl font-extrabold text-slate-900 leading-tight mb-6">
              Apni Dukaan Ko <br />
              <span className="text-emerald-600 italic">Digital Banao</span>
            </h1>

            <p className="text-xl text-gray-600 mb-10 max-w-lg mx-auto lg:mx-0">
              Billing, smart inventory, QR menu ordering — सब कुछ एक App में।
              Increase your sales by 30% with RetailMitra.
            </p>

            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-4">
              
              {/* Google Play Button (Linked) */}
              <a
                href="https://play.google.com/store/apps/details?id=com.retailmitra&hl=en_IN"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 bg-black text-white px-8 py-4 rounded-2xl hover:bg-slate-800 transition"
              >
                <Play fill="white" size={20} />
                <div className="text-left">
                  <p className="text-[10px] uppercase">Get it on</p>
                  <p className="text-lg font-semibold leading-none">
                    Google Play
                  </p>
                </div>
              </a>

              {/* App Store (Coming Soon) */}
              <button className="flex items-center gap-3 bg-white border-2 border-slate-200 text-slate-900 px-8 py-4 rounded-2xl hover:border-slate-400 transition">
                <Apple fill="black" size={20} />
                <div className="text-left">
                  <p className="text-[10px] uppercase">Download on the</p>
                  <p className="text-lg font-semibold leading-none">
                    App Store
                  </p>
                </div>
              </button>

            </div>
          </div>

          {/* Right Content – Premium Mobile Interface */}
          <div className="relative flex justify-center">
            <div className="absolute w-[420px] h-[420px] bg-emerald-200 rounded-full blur-3xl opacity-40"></div>

            <div className="relative w-[280px] h-[580px] rounded-[3rem] bg-black border-[10px] border-slate-800 shadow-[0_40px_120px_rgba(0,0,0,0.25)] overflow-hidden">
              <div className="absolute top-2 left-1/2 -translate-x-1/2 w-24 h-4 bg-black rounded-full z-10"></div>

              <img
                src={appMockup}
                alt="RetailMitra App Interface"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>

            <div className="absolute top-24 -right-0 bg-white px-4 py-3 rounded-2xl shadow-xl border border-slate-100">
              <p className="text-xs text-gray-500">Today’s Sales</p>
              <p className="text-xl font-bold text-emerald-600">₹24,580</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;
